import { FC } from 'react'

/**
 * * Icon Component for: help-circle-contained
 */
type HelpCircleOutlinedIconProps = {
  size?: number
  color?: string
}
export const HelpCircleOutlinedIcon: FC<HelpCircleOutlinedIconProps> = ({
  size = '1rem',
  color = 'currentColor',
  ...rest
}) => {
  const iconAttributes = {
    width: size,
    height: size,
  }
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" {...rest} {...iconAttributes}>
      <path
        d="M9.99902 14.5V14.5396M7.75 7.22999C7.75 5.96388 8.75736 4.9375 10 4.9375C11.2426 4.9375 12.25 5.96388 12.25 7.22999C12.25 8.4961 11.2426 9.52249 10 9.52249C10 9.52249 9.99902 10.2067 9.99902 11.0508M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
